var _ref2, _ref3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocumentDownload = function SvgDocumentDownload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 19.362,
    height: 24.5,
    viewBox: "0 0 19.362 24.5",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("defs", null, React.createElement("style", null, ".a{fill:#191919;stroke:#191919;stroke-width:0.5px;}.b{fill:#3aaa35;}"))), _ref3 || (_ref3 = React.createElement("g", {
    transform: "translate(-143.221 -365.75)"
  }, React.createElement("path", {
    className: "a",
    d: "M18.862,4.762a.115.115,0,0,0-.031-.094h0c-.031-.063-.063-.094-.094-.157h0L14.287.125a.031.031,0,0,1-.031-.031L14.225.063a.031.031,0,0,1-.031-.031L14.162,0H1A.993.993,0,0,0,.282.282.993.993,0,0,0,0,1V23a.993.993,0,0,0,.282.721A.993.993,0,0,0,1,24H17.859a.965.965,0,0,0,1-1V4.762ZM14.413,1.6l2.82,2.789h-2.82ZM17.922,23v.063H.94V.94H13.473V4.856a.482.482,0,0,0,.47.47h3.979Z",
    transform: "translate(143.471 366)"
  }), React.createElement("g", {
    transform: "translate(0 -3)"
  }, React.createElement("path", {
    className: "b",
    d: "M6,0l6,6H0Z",
    transform: "translate(159 387) rotate(180)"
  }), React.createElement("rect", {
    className: "b",
    width: 4,
    height: 7,
    transform: "translate(151 375)"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDocumentDownload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documentDownload.a5043b0d.svg";
export { ForwardRef as ReactComponent };